import React from 'react';
import '../styles/kerala.css';
import logo from "../assets/logo3.webp";
import { Link, useLocation } from "react-router-dom";
import keralaData from '../data/kerala.json';
import keralaBanner from '../assets/kerala.webp';

const imageMap = {
  '../assets/alleppey.png': require('../assets/alleppey.png'),
  '../assets/munnar.png': require('../assets/munnar.jpg'),
  '../assets/kumarakon.png': require('../assets/kumarakon.png'),
  '../assets/calungutebeach.png': require('../assets/calungutebeach.png'),
  '../assets/colvabeach.png': require('../assets/colvabeach.png'),
  '../assets/vagatorbeach.png': require('../assets/vagatorbeach.png'),
  '../assets/morjimbeach.png': require('../assets/morjimbeach.png'),
  '../assets/arambolbeach.png': require('../assets/arambolbeach.png'),
  '../assets/butterflybeach.png': require('../assets/butterflybeach.png'),
  '../assets/candolimbeach.png': require('../assets/candolimbeach.png'),
  '../assets/cabana.png': require('../assets/cabana.png'),
  '../assets/titos.png': require('../assets/titos.png'),
  '../assets/mambos.png': require('../assets/mambos.png'),
  '../assets/sinq.png': require('../assets/sinq.png'),
  '../assets/lpk.png': require('../assets/lpk.png'),
  '../assets/hilltop.png': require('../assets/hilltop.png'),
  '../assets/cavala.png': require('../assets/cavala.png'),
  '../assets/toro.png': require('../assets/toro.png'),
  '../assets/chronicle.png': require('../assets/chronicle.png'),
  '../assets/Cohiba.png': require('../assets/Cohiba.png'),
  '../assets/thalassa.png': require('../assets/thalassa.png'),
  '../assets/artjuna.png': require('../assets/artjuna.png'),
  '../assets/eva.png': require('../assets/eva.png'),
  '../assets/sakana.png': require('../assets/sakana.png'),
  '../assets/gunpowder.png': require('../assets/gunpowder.png'),
  '../assets/baba.png': require('../assets/baba.png'),
  '../assets/chocolatti.png': require('../assets/chocolatti.png'),
  '../assets/pousada.png': require('../assets/pousada.png'),
  '../assets/curlies.png': require('../assets/curlies.png'),
'../assets/taj.png': require('../assets/taj.png'),
'../assets/leela.png': require('../assets/leela.png'),
'../assets/itc.png': require('../assets/itc.png'),
'../assets/alila.png': require('../assets/alila.png'),
'../assets/cidade.png': require('../assets/cidade.png'),
'../assets/w.png': require('../assets/w.png'),
'../assets/planet.png': require('../assets/planet.png'),
'../assets/fairfield.png': require('../assets/fairfield.png'),
'../assets/acron.png': require('../assets/acron.png'),
'../assets/lavie.png': require('../assets/lavie.png'),
'../assets/thekkady.png': require('../assets/thekkady.png'),
'../assets/wayanad.png': require('../assets/wayanad.png'),
'../assets/kovalam.png': require('../assets/kovalam.png'),
'../assets/varkala.png': require('../assets/varkala.png'),
'../assets/athirappilly.png': require('../assets/athirappilly.png'),
'../assets/bekal.png': require('../assets/bekal.png'),
'../assets/bekal.png': require('../assets/bekal.png'),
'../assets/kochi.png': require('../assets/kochi.png'),
'../assets/kathakali.png': require('../assets/kathakali.png'),
'../assets/kalaripayattu.png': require('../assets/kalaripayattu.png'),
'../assets/onam.png': require('../assets/onam.png'),
'../assets/theyyam.png': require('../assets/theyyam.png'),
'../assets/snakeboat.png': require('../assets/snakeboat.png'),
'../assets/sadhya.png': require('../assets/sadhya.png'),
'../assets/Mohiniyattam.png': require('../assets/Mohiniyattam.png'),
'../assets/templeelephant.png': require('../assets/templeelephant.png'),
'../assets/toddy.png': require('../assets/toddy.png'),
'../assets/kairali.png': require('../assets/kairali.png'),
'../assets/somatheeram.png': require('../assets/somatheeram.png'),
'../assets/ayurveda.png': require('../assets/ayurveda.png'),
'../assets/poovar.png': require('../assets/poovar.png'),
'../assets/punarnava.png': require('../assets/punarnava.png'),
'../assets/ananda.png': require('../assets/ananda.png'),
'../assets/greenayurveda.png': require('../assets/greenayurveda.png'),
'../assets/kettuvallam.png': require('../assets/kettuvallam.png'),
'../assets/honeymoon.png': require('../assets/honeymoon.png'),
'../assets/deluxe.png': require('../assets/deluxe.png'),
'../assets/budget.png': require('../assets/budget.png'),
'../assets/deluxe.png': require('../assets/deluxe.png'),
'../assets/heritage.png': require('../assets/heritage.png'),
'../assets/tajgreen.png': require('../assets/tajgreen.png'),
'../assets/elixir.png': require('../assets/elixir.png'),
'../assets/zuri.png': require('../assets/zuri.png'),
'../assets/vythiri.png': require('../assets/vythiri.png')
};

const Kerala = () => {
  const location = useLocation();
  return (
    <>
          {/* Header Section */}
      <header className="contact-header over-banner">
        <div className="contact-logo">
          <img src={logo} alt="Tourly Logo" />
        </div>
        <nav className="contact-nav">
          <Link to="/">Home</Link>
          <Link to="/packages">Packages</Link>
          <div className="contact-dropdown">
  <a href="#" className={`contact-dropbtn ${location.pathname === '/kerala' ? 'active-link' : ''}`}>Destinations</a> 
<div className="contact-dropdown-content">
              <Link to="/goa">Goa</Link>
              <Link to="/kerala">Kerala</Link>
              <Link to="/rajasthan">Rajasthan</Link>
              <Link to="/himachal">Himachal Pradesh</Link>
              <Link to="/uttarakhand">Uttarakhand</Link>
                <Link to="/abu">Abu Dhabi</Link>
                <Link to="/dubai">Dubai</Link>
            </div>
          </div>
            <Link to="/hotels">Hotels</Link>
        <Link to="/contact-us" className={location.pathname === '/contact-us' ? 'active-link' : ''}>Contact Us</Link>
          
        </nav>
          <Link to="/booknow">
                <button className="contact-book-btn">Book Now</button>
                            </Link>
      </header>
    <div className="Kerala-page">
      <div className="Kerala-hero">
        <div className="Kerala-hero-overlay">
          <h1>Explore Kerala</h1>
          <p>Backwaters, Hills, Culture – God's Own Country Awaits</p>
        </div>
        <img src={keralaBanner} alt="Kerala Banner" className="Kerala-hero-img" />
      </div>

      <section className="Kerala-info">
        <h2>Welcome to Kerala</h2>
        <p>
         Kerala offers serene backwaters, misty hills, vibrant culture, and Ayurvedic wellness. Discover pristine beaches, delicious cuisine, and ancient traditions in "God's Own Country"—your perfect escape for relaxation or adventure.
        </p>
      </section>

      {Object.entries(keralaData).map(([sectionTitle, items]) => (
        <section className="Kerala-section" key={sectionTitle}>
          <h2>{formatTitle(sectionTitle)}</h2>
          <div className="Kerala-cards-container">
            {items.map((item, index) => (
              <div className="Kerala-card" key={index}>
             < img
                  src={imageMap[item.image] || item.image}
                  alt={item.name}
                />
                <h3>{item.name}</h3>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
    </>
  );
};

const formatTitle = (key) => {
  switch (key) {
    case 'Backwaters': return 'Places';
    case 'Culture': return 'Culture';
    case 'Houseboats': return 'Houseboats and Resorts';
    case 'Resorts': return 'Resorts';
    case 'Ayurveda': return 'Ayurveda';
    default: return key;
  }
};

export default Kerala;
